import {
  SET_PROCESS_ALERT,
  LIST_PROCESS_DATA_SUCCESS,
  LIST_PROCESS_DATA_FAILED,
  LIST_UNIQUE_ASSET_SECTION,
  LIST_STITCHED_PROCESS_DATA_SUCCESS,
  LIST_ENHANCED_DATA_SUCCESS,
  LIST_ENHANCED_DATA_SUCCESS_LOADING,
  PROCESS_TAB_INPROGRESS,
  IN_PROGRESS_ENHANCE_UPLOAD,
  IN_PROGRESS_STITCH_UPLOAD,
  IN_UPLOADING_ENHANCE_UPLOAD,
  SET_DATA_DELETE_LOADING,
  IN_PROGRESS_ENHANCE_UPLOAD_COUNT,
} from '../actions/types';
const initialState = {
  isAlert: false,
  alertType: null,
  alertMessage: null,
  data: [],
  sectionData: [],
  sectionLoading: true,
  stitchedImages: [],
  enhancedImages: [],
  enhancedImagesLoading: false,
  inProgress: false,
  inProgressType: '',
  inProgressValue: null,
  inProgressStitchValue: null,
  isUploading: false,
  dataDeleteLoading: false,
  countProgress: '1/1',
};

function userReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case IN_PROGRESS_ENHANCE_UPLOAD_COUNT:
      return {
        ...state,
        countProgress: payload,
      };
    case SET_DATA_DELETE_LOADING:
      return {
        ...state,
        dataDeleteLoading: payload,
      };
    case IN_UPLOADING_ENHANCE_UPLOAD:
      return {
        ...state,
        isUploading: payload,
      };
    case IN_PROGRESS_STITCH_UPLOAD:
      return {
        ...state,
        inProgressStitchValue: payload,
      };
    case IN_PROGRESS_ENHANCE_UPLOAD:
      return {
        ...state,
        inProgressValue: payload,
      };
    case PROCESS_TAB_INPROGRESS:
      return {
        ...state,
        inProgress: payload.status,
        inProgressType: payload.type,
      };
    case LIST_ENHANCED_DATA_SUCCESS:
      return {
        ...state,
        enhancedImages: payload,
        enhancedImagesLoading: false,
      };
    case LIST_ENHANCED_DATA_SUCCESS_LOADING:
      return {
        ...state,
        enhancedImagesLoading: payload,
      };
    case LIST_STITCHED_PROCESS_DATA_SUCCESS:
      return {
        ...state,
        stitchedImages: payload,
      };
    case LIST_UNIQUE_ASSET_SECTION:
      return {
        ...state,
        sectionData: payload,
        sectionLoading: false,
      };
    case LIST_PROCESS_DATA_FAILED:
      return {
        ...state,
        data: [],
      };
    case LIST_PROCESS_DATA_SUCCESS:
      return {
        ...state,
        data: payload,
      };
    case SET_PROCESS_ALERT:
      return {
        ...state,
        isAlert: payload.isAlert,
        alertType: payload.alertType,
        alertMessage: payload.alertMessage,
      };
    default:
      return state;
  }
}

export default userReducer;
